import { ActivityIndicator, Dimensions, Image, Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import React, { useState } from 'react';
import Typography from '../../typography/Typography';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { addCommasToNumber, isFromTDLPlatform } from '../utils';
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import { SHIMMER_PAGE } from "./constant";
import ThemeProvider from '@voltmoney/theme';
import Space from '../../space/Space';
import * as Animatable from 'react-native-animatable';
const ResultSection = ({ totalAmount, fetchMF, triggerAction, showEditLimit, onEditLimitPressed, latestDateOfEdit, loading }) => {
    const [editLimit, setEditLimit] = useState(showEditLimit);
    const screenWidth = Dimensions.get('window').width;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const isfromTDL = isFromTDLPlatform();
    // @ts-ignore
    return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
        React.createElement(View, { style: styles.container },
            React.createElement(View, { style: editLimit ? styles.headingWhenEditLimitShown : styles.heading },
                React.createElement(Typography, { label: editLimit ? "Selected credit limit" : "Available credit limit", fontSize: FontSizeTokens.SM, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 20 }),
                React.createElement(Typography, { label: '₹' + addCommasToNumber(totalAmount), fontSize: FontSizeTokens.XXL, fontWeight: '700', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Secondary_100, lineHeight: 32 })),
            editLimit ?
                React.createElement(View, { style: styles.subHeadingAndroidIOS },
                    React.createElement(View, { style: {
                            height: 30,
                            backgroundColor: "#F1F3F5",
                            borderRadius: 6,
                            paddingHorizontal: 12,
                            paddingVertical: 6,
                            flexDirection: 'row',
                            marginLeft: 20,
                            marginRight: 16,
                            marginBottom: 16,
                            alignContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: `Last checked on ${latestDateOfEdit}`, color: ColorTokens.Grey_Charcoal }))),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            alignContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginBottom: 16,
                            justifyContent: 'center',
                            flex: 1,
                            padding: 16
                        } },
                        React.createElement(View, { style: { flex: 0.38, marginRight: 8, height: 32 } },
                            React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, sizeDLS: Platform.OS === 'ios' ? ButtonSizeDLS.SMALL : ButtonSizeDLS.MEDIUM, label: "Edit limit", fontSize: FontSizeTokens.XS, paddingHorizontalDC: 10, onPress: () => {
                                    onEditLimitPressed(true);
                                } })),
                        React.createElement(View, { style: { flex: 0.62, height: 32 } }, Platform.OS === "ios" ? React.createElement(TouchableOpacity, { onPress: () => triggerAction({
                                ...fetchMF
                            }), style: { justifyContent: 'center', flexDirection: 'row', alignItems: 'center', height: 32, borderRadius: isfromTDL ? 8 : 1000, backgroundColor: "#1434CB" } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: 'Continue application', color: ColorTokens.White }),
                            React.createElement(View, { style: { marginLeft: 10, marginTop: 2 } },
                                React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.MD, color: ColorTokens.White }))) :
                            React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Continue application", icon: { name: IconTokens.RightArrow }, fontSize: FontSizeTokens.XS, iconName: IconTokens.ChervonDownRight, onPress: () => {
                                    triggerAction({
                                        ...fetchMF
                                    });
                                }, loading: loading, paddingHorizontalDC: screenWidth > 390 ? 32 : 16 }))))
                : React.createElement(View, { style: styles.subHeading },
                    React.createElement(View, { style: styles.subHeadingContainer },
                        React.createElement(View, { style: styles.imageContainer },
                            React.createElement(Image, { source: { uri: SHIMMER_PAGE }, style: styles.shimmerImage })),
                        React.createElement(View, { style: styles.textContainer },
                            React.createElement(Typography, { label: "You’re almost there!", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                            React.createElement(Typography, { label: "Finish application in a few minutes", fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 18 }))),
                    React.createElement(View, { style: styles.buttonContainer, nativeID: 'bt_landingScreen_continueApplication' },
                        React.createElement(TouchableOpacity, { activeOpacity: 1, style: [styles.frameButtonContainer, { backgroundColor: colorMapping[ColorTokens.Primary_100], borderRadius: isfromTDL ? 8 : 1000 }], onPress: () => {
                                if (fetchMF) {
                                    triggerAction(fetchMF);
                                }
                            } },
                            React.createElement(View, { style: styles.eligibleText },
                                React.createElement(Typography, { label: "Continue application", fontSize: FontSizeTokens.MD, fontWeight: '700', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.White, lineHeight: 24 })),
                            !loading && (React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Space, { size: SizeTypeTokens.XL }))),
                            loading && (React.createElement(ActivityIndicator, { style: { marginLeft: 8 }, animating: true, size: 16, color: theme.colors[ColorTokens.White] }))))))));
};
export default ResultSection;
const styles = StyleSheet.create({
    container: {
        marginTop: 16,
        marginHorizontal: 16,
    },
    heading: {
        backgroundColor: 'white',
        borderColor: '#E4E7EC',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderWidth: 1,
        paddingTop: 20,
        paddingLeft: 23,
        paddingBottom: 12,
        borderBottomWidth: 0,
        elevation: 20,
        shadowColor: '#98A2B3',
        zIndex: 1,
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.20,
        shadowRadius: 4.65,
    },
    headingWhenEditLimitShown: {
        backgroundColor: 'white',
        borderColor: '#E4E7EC',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        paddingTop: 20,
        paddingLeft: 23,
        paddingBottom: 8
    },
    subHeading: {
        backgroundColor: '#FFFFFF',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        borderTopWidth: 0,
        borderWidth: 1,
        borderColor: '#E4E7EC',
        elevation: 20,
    },
    subHeadingAndroidIOS: {
        backgroundColor: '#FFFFFF',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        borderTopWidth: 0,
    },
    shimmerImage: {
        height: 50,
        width: 50,
    },
    subHeadingContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    imageContainer: {
        paddingLeft: 22,
        paddingTop: 24,
    },
    textContainer: {
        marginLeft: 16,
        paddingTop: 24,
    },
    buttonContainer: {
        width: '100%',
        marginTop: 25,
        paddingLeft: 17,
        paddingBottom: 18,
        paddingRight: 15,
        elevation: 24,
    },
    eligibleText: {
        paddingVertical: 12,
        justifyContent: 'center',
        alignItems: 'center',
    },
    frameButtonContainer: {
        flexDirection: 'row',
        elevation: 24,
        shadowColor: '#1434CB',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: Platform.OS === 'web' && '0 16px 24px 0 rgba(20, 52, 203, 0.25)'
    },
});
